<div style="min-height: 300px; position: relative; display: flex; align-items: center; justify-content: center; flex-direction: column;" *ngIf="isSaving">
  <div class="lds-dual-ring"></div>
  <span>saving</span>
</div>

<form *ngIf="!isSaving" class="add-address-form" [ngClass]="{'with-padding': addPadding }" [formGroup]="contactForm">
  <div class="androweb-form-rule" id="required-fields-rule" *ngIf="!contactForm.valid && showRequiredRule">
    <p class="androweb-form-rule-red">* </p>
    <p class="androweb-form-rule-text"> Required Fields</p>
  </div>

  <div [ngClass]="{'sticky-footer': showStickyFooter}" appViewHeight [viewHeightDisabled]="!showStickyFooter" [offset]="125">
    <app-androweb-input [formControl]="contactForm.controls['MobilePhone'] | formControl"
                        [label]="'Mobile Phone Number'"
                        [placeHolder]="mobilePhonePlaceholder"
                        [patternError]="'Please Enter a valid phone number'"
                        [maxLength]="15"
                        [matIcon]="'smartphone'"
                        [type]="'tel'"
                        [showInputError]="showValidationErrors"
                        ngDefaultControl></app-androweb-input>

    <div class="androweb-form-group">
      <label> Enter Your Postcode </label>
      <div class="input-group mb-2 mr-sm-2 postcode-search">
        <input type="text"
               style="margin-left: 0 !important; text-transform: uppercase;"
               [value]="storedPostCode ?? ''"
               maxlength="10"
               #findByPostCodeInput
               autocomplete="off" />
        <button type="button"
                class="button-action-1"
                mat-raised-button
                (click)="getAddressFromPostCode(findByPostCodeInput.value)">Find</button>
      </div>
    </div>
 
    <mat-form-field class="postcode-select" *ngIf="addressesForPostCode?.length > 0">
      <mat-select placeholder="Choose your address" (selectionChange)="selectAddress($event.value, findByPostCodeInput.value)">
        <mat-option disabled> -- Choose your address -- </mat-option>
        <mat-option [value]="address" *ngFor="let address of addressesForPostCode">
          {{ address.line_1 + (address.line_2 ? ', ' + address.line_2 : '') + (address.town_or_city ? ', ' + address.town_or_city : '') }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="no-addresses-found" *ngIf="postcodeSearchComplete && addressesForPostCode.length === 0">
      Sorry we couldn't find your address, please enter it manually.
    </div>

    <div style="text-align: center; text-decoration: underline; cursor: pointer; color: #007FFF;"
         (click)="showExpandedAddress = true" *ngIf="!showExpandedAddress">
      <span>or click here to manually enter an address.</span>
    </div>

    <ng-container *ngIf="showExpandedAddress">
      <app-androweb-input [formControl]="contactForm.controls['AddressLine1'] | formControl"
                          [label]="'Street Address'"
                          [placeHolder]="'Company Name, Street and number'"
                          [patternError]="'Please Enter a valid phone number'"
                          [maxLength]="50"
                          [matIcon]="'add_road'"
                          [showInputError]="showValidationErrors"
                          ngDefaultControl>
      </app-androweb-input>

      <app-androweb-input [formControl]="contactForm.controls['AddressLine2'] | formControl"
                          [label]="'Building Name/Number'"
                          [placeHolder]="'Flat, Suite, Unit, Building, Floor, etc'"
                          [maxLength]="50"
                          [matIcon]="'home'"
                          [showInputError]="showValidationErrors"
                          ngDefaultControl>
      </app-androweb-input>

      <app-androweb-input [formControl]="contactForm.controls['Town'] | formControl"
                          [label]="'Town'"
                          [placeHolder]="'Town'"
                          [maxLength]="50"
                          [matIcon]="'map'"
                          [showInputError]="showValidationErrors"
                          ngDefaultControl>
      </app-androweb-input>

      <app-androweb-input [formControl]="contactForm.controls['PostCode'] | formControl"
                          [label]="'Postcode'"
                          [placeHolder]="'Postcode'"
                          [patternError]="'Please Enter a valid Postcode'"
                          [maxLength]="10"
                          [text-transform]="'uppercase'"
                          [matIcon]="'mail'"
                          [showInputError]="showValidationErrors"
                          ngDefaultControl>
      </app-androweb-input>

      <div class="add-address-section androweb-form-group" style="display: flex; flex-direction: column;" *ngIf="showNotes">
        <label>Notes</label>
        <textarea [formControlName]="'DeliveryNote'"
                  id="delivery-note"
                  [maxlength]="80"
                  [placeholder]="'Delivery Directions'"></textarea>
      </div>

      <app-androweb-input [formControl]="contactForm.controls['Nickname'] | formControl"
                          [label]="'Address Name'"
                          [placeHolder]="'Home/Work/Other'"
                          [maxLength]="80"
                          [matIcon]="'location_on'"
                          *ngIf="showAddressName"
                          [showInputError]="showValidationErrors"
                          ngDefaultControl>
      </app-androweb-input>
    </ng-container>
  </div>

  <div class="login-action" *ngIf="saveVisibilityState === 'AlwaysVisible' || (saveVisibilityState === 'Visible' && showExpandedAddress)">
    <button class="button button-action-2" type="reset" (click)="cancelClicked()">Cancel</button>
    <button class="button button-action-1" (click)="saveClicked()">
      {{ saveButtonTitle }}
    </button>
  </div>
</form>
